package ru.education.building.schedule.widgets.calendar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.layout.SubcomposeLayout
import com.kizitonwose.calendar.compose.CalendarState
import com.kizitonwose.calendar.compose.weekcalendar.WeekCalendarState
import com.kizitonwose.calendar.core.CalendarMonth
import com.kizitonwose.calendar.core.minusDays
import com.kizitonwose.calendar.core.plusDays
import kotlinx.coroutines.flow.filter
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.LocalDate
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.minus
import kotlinx.datetime.yearMonth


fun LocalDate.getFirstDayOfWeek(firstDayOfWeek: DayOfWeek = DayOfWeek.MONDAY): LocalDate {
    val daysFromStart = (dayOfWeek.isoDayNumber - firstDayOfWeek.isoDayNumber).mod(7)
    return minus(daysFromStart, DateTimeUnit.DAY)
}

fun LocalDate.isSameWeek(other: LocalDate, firstDayOfWeek: DayOfWeek = DayOfWeek.MONDAY): Boolean {
    return getFirstDayOfWeek(firstDayOfWeek) == other.getFirstDayOfWeek(firstDayOfWeek)
}

@Composable
fun rememberVisibleWeekAndMonthAfterScroll(isWeekMode: Boolean, weekState: WeekCalendarState, monthState: CalendarState): String {
    var visibleMonth by rememberSaveable { mutableStateOf(weekState.firstVisibleWeek.days.first().date.yearMonth.month.toString()) }
    if (isWeekMode) {
        // фикс криворуксти разработчика библиотеки, с inScrollInProgress работать не будет!!
        if ((weekState.firstVisibleWeek.days.first().date.month.toString() != weekState.firstVisibleWeek.days.last().date.month.toString())) {
            LaunchedEffect(weekState) {
                snapshotFlow { weekState.isScrollInProgress }
                    .filter { scrolling -> !scrolling }
                    .collect { visibleMonth = weekState.firstVisibleWeek.days.first().date.minusDays(7).month.toString() }
            }
            return visibleMonth
        } else if ((weekState.firstVisibleWeek.days.first().date.month.toString() == weekState.firstVisibleWeek.days.last().date.month.toString())) {
            LaunchedEffect(weekState) {
                snapshotFlow { weekState.isScrollInProgress }
                    .filter { scrolling -> !scrolling }
                    .collect { visibleMonth = weekState.firstVisibleWeek.days.last().date.month.toString() }
            }
            return visibleMonth
        }
    } else if (monthState.isScrollInProgress){
        LaunchedEffect(monthState) {
            snapshotFlow { monthState.isScrollInProgress }
                .filter { scrolling -> !scrolling }
                .collect { visibleMonth = monthState.firstVisibleMonth.yearMonth.month.toString() }
        }
        return visibleMonth
    }
    return visibleMonth
}

@Composable
fun rememberVisibleWeekAndMonthAfterScroll_Unstable(isWeekMode: Boolean, weekState: WeekCalendarState, monthState: CalendarState): String {
    var visibleMonth by rememberSaveable { mutableStateOf(weekState.firstVisibleWeek.days.first().date.yearMonth.month.toString()) }
    if (isWeekMode and weekState.isScrollInProgress) {
        if ((weekState.firstVisibleWeek.days.first().date.month.toString() != weekState.firstVisibleWeek.days.last().date.month.toString())) {
            LaunchedEffect(weekState) {
                snapshotFlow { weekState.isScrollInProgress }
                    .filter { scrolling -> !scrolling }
                    .collect { visibleMonth = weekState.firstVisibleWeek.days.first().date.minusDays(7).month.toString() }
            }
            println(weekState.firstVisibleWeek.days.first().date.day)
            println(weekState.firstVisibleWeek.days.last().date.day)
            println("1 " + weekState.firstVisibleWeek.days.first().date.minusDays(7))
            return visibleMonth
        } else if ((weekState.firstVisibleWeek.days.first().date.month.toString() == weekState.firstVisibleWeek.days.last().date.month.toString())) {
            LaunchedEffect(weekState) {
                snapshotFlow { weekState.isScrollInProgress }
                    .filter { scrolling -> !scrolling }
                    .collect { visibleMonth = weekState.firstVisibleWeek.days.last().date.month.toString() }
            }
            println((weekState.firstVisibleWeek.days.first().date.toString() == weekState.firstVisibleWeek.days.last().date.toString()))
            println("2 " + weekState.firstVisibleWeek.days.last().date.plusDays(1))
            return visibleMonth
        }
    } else {
        if (monthState.canScrollBackward && monthState.isScrollInProgress) {
            LaunchedEffect(monthState) {
                snapshotFlow { monthState.isScrollInProgress }
                    .filter { scrolling -> !scrolling }
                    .collect { visibleMonth = monthState.firstVisibleMonth.yearMonth.month.toString() }
            }
            println("3 " + monthState.firstVisibleMonth.yearMonth)
            return visibleMonth
        } else  if (monthState.canScrollForward && monthState.isScrollInProgress) {
            LaunchedEffect(monthState) {
                snapshotFlow { monthState.isScrollInProgress }
                    .filter { scrolling -> !scrolling }
                    .collect { visibleMonth = monthState.firstVisibleMonth.yearMonth.previousMonth.month.toString() }
            }
            println("4 " + monthState.firstVisibleMonth.yearMonth.previousMonth)
            return visibleMonth
        }
    }
    return visibleMonth
}

@Composable
fun rememberFirstVisibleMonthAfterScroll_Deprecated(state: CalendarState, isAnimating: Boolean): CalendarMonth {
    val visibleMonth = remember(state) { mutableStateOf(state.firstVisibleMonth) }
    //val fixVisibleMonth = listOf(visibleMonth.value).toPersistentList()
    val fixVisibleMonth = listOf(visibleMonth.value).toList()
    if (!isAnimating) {
        LaunchedEffect(state) {
            snapshotFlow { state.isScrollInProgress }
                .filter { scrolling -> !scrolling }
                .collect { visibleMonth.value = state.firstVisibleMonth }
        }
        return visibleMonth.value
    }
    return fixVisibleMonth.first()
}

@Composable
private fun TopCenteredOverBottom(
    spacing: Int = 8,
    top: @Composable () -> Unit,
    bottom: @Composable () -> Unit
) {
    SubcomposeLayout { constraints ->
        val bottomP = subcompose("bottom", bottom).single().measure(constraints)
        val topP = subcompose("top", top).single().measure(constraints)

        val width = maxOf(constraints.minWidth, maxOf(topP.width, bottomP.width))
        val height = topP.height + spacing + bottomP.height

        // Центрируем нижний в родителе
        val bottomX = (width - bottomP.width) / 2
        val topX = bottomX + (bottomP.width - topP.width) / 2
        val topY = 0
        val bottomY = topP.height + spacing

        layout(width, height) {
            topP.placeRelative(topX, topY)
            bottomP.placeRelative(bottomX, bottomY)
        }
    }
}